/**
 * @module Utils
 */

/**
 * Normalize an Ember Data collection to a plain array.
 *
 * `store.peekAll(...)` returns a `RecordArray` and synchronous `hasMany`
 * accessors return a `ManyArray` — both are array-like Ember objects whose
 * declared TypeScript types don't reliably expose `.toArray()`. This collapses
 * either of those (or a value that's already a plain array, or null/undefined)
 * to a plain `T[]`, so callers can use native array methods without repeating a
 * `toArray?.()`-or-fallback cast at every site.
 */
export default function toArray<T>(value: unknown): T[] {
  if (Array.isArray(value)) {
    return value as T[];
  }
  const arrayLike = value as { toArray?: () => T[] } | null | undefined;
  return arrayLike?.toArray?.() ?? [];
}
